var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.role=='hq_admin')?_c('admin-account-manage'):_vm._e(),(_vm.role=='store_admin'||_vm.role=='store_sa')?_c('store-account-manage'):_vm._e(),(_vm.role=='store_editor')?_c('editor-account-manage'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }